import React from 'react'
import './button.css'

const Button = () => {
  return (
    <a  className='red-button'>
      Explore All Product
    </a>
  )
}

export default Button